import Client from '@/services/api/client.js';

export default {
  namespaced: true,
  state: {
    clients: [],
    client: {},
  },
  getters: {
    clients: state => state.clients,
    client: state => state.client,
  },
  mutations: {
    setClients: (state, clients) => {
      state.clients = clients;
    },
    setClient: (state, client) => {
      state.client = client;
    },
  },
  actions: {
    loadClients (state, options = {}) {
      return new Promise((resolve, reject) => {
        Client.getClients(options)
          .then(({ data }) => {
            state.commit('setClients', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    loadClient (state, { id, options = {} }) {
      return new Promise((resolve, reject) => {
        Client.getClient(id, options)
          .then(({ data }) => {
            state.commit('setClient', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateClient (state, payload) {
      return new Promise((resolve, reject) => {
        Client.updateClient(payload)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    newClient (state, params) {
      return new Promise((resolve, reject) => {
        Client.newClient(params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    addClientAbonent (state, { clientId, abonentId }) {
      return new Promise((resolve, reject) => {
        Client.addClientAbonent(clientId, abonentId)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    exportCsv (state) {
      return new Promise((resolve, reject) => {
        Client.exportCsv()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    deleteClient (state, id) {
      return new Promise((resolve, reject) => {
        Client.deleteClient(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => console.error(e));
      });
    },
    getCarNumberChangesHistory (state, params = {}) {
      return Client.getCarNumberChangesHistory(params)
        .then((response) => {
          return response.data;
        })
        .catch(e => {
          throw e;
        });
    },
    getGuestAccessHistory (state, params = {}) {
      return Client.getGuestAccessHistory(params)
        .then((response) => {
          return response.data;
        })
        .catch(e => {
          throw e;
        });
    },
    activateCarNumber (state, { clientId, car_number_id, barrier_ids }) {
      return Client.activateCarNumber(clientId, { car_number_id, barrier_ids });
    },
  },
};
